import { createClient } from '@sanity/client'
import { createImageUrlBuilder } from '@sanity/image-url'

export const sanity = createClient({
  projectId: 'msjo230z',
  dataset: 'production',
  apiVersion: '2025-01-01',
  useCdn: true,
})

const builder = createImageUrlBuilder(sanity)

export function urlFor(source) {
  return builder.image(source)
}
